export const hashCode = (text: string) => text.split('').reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);
